import { api } from "@/lib/api";

const cache = new Map();

export const clearShareCache = () => cache.clear();

export const openShare = (opts) => window.dispatchEvent(new CustomEvent("itz-share", { detail: opts }));

export async function getShareUrl({ kind, target, text }) {
  const key = `${kind}|${target || ""}|${text || ""}`;
  if (!cache.has(key)) {
    const p = api.post("/share/link", { kind, target, text }).then(({ data }) => data.url);
    cache.set(key, p);
    p.catch(() => cache.delete(key));
  }
  return cache.get(key);
}

export function captureRefParams() {
  const sp = new URLSearchParams(window.location.search);
  const ref = sp.get("ref"), sl = sp.get("sl");
  if (ref) localStorage.setItem("itz_ref", ref);
  if (sl) localStorage.setItem("itz_sl", sl);
}

export const takeShareCode = () => localStorage.getItem("itz_sl") || null;
export const clearShareCode = () => localStorage.removeItem("itz_sl");
